exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li .ui-dropdown.ui-widget.ui-state-default.ui-corner-all.ui-helper-clearfix{width:65px}li .country-selector{width:100px!important}li .ui-dropdown{min-width:4rem!important}li .ui-dropdown-panel .ui-dropdown-filter-container .fa{right:30px!important;top:19px!important}li .ui-dropdown-panel .ui-dropdown-filter-container{max-width:184px!important}.reverb-admin .ui-dropdown-label{text-overflow:ellipsis!important;padding-right:40px!important}", ""]);

// exports
